import React, { useEffect, useRef } from "react";

const RichContent = React.forwardRef(({ content, className = "", style = {}, internalClassName = "", maxLines = 0 }, ref) => {
  const internalRef = useRef(null);
  const containerRef = ref || internalRef;

  useEffect(() => {
    if (!containerRef.current) return;

    // Only attach the shadow root if it doesn't already exist
    const shadow = containerRef.current.shadowRoot || containerRef.current.attachShadow({ mode: "open" });

    const maxLinesStyle = maxLines > 0 ? `
      max-height: ${maxLines * 1.6}em; /* Approximation of line height */
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: ${maxLines};
      overflow: hidden;
    ` : "";

    shadow.innerHTML = `
      <style>
@import url('https://fonts.googleapis.com/css2?family=Oswald&display=swap');

        :host {
          all: initial;
          display: block;
          width: 100%;
          overflow-x: auto;
        }

        .rich-content-body {
          color: inherit;
          font-family: Arial, Helvetica, sans-serif;
          line-height: normal;
          -webkit-font-smoothing: auto;
          -moz-osx-font-smoothing: auto;
          width: 100%;
          box-sizing: border-box;
          ${maxLinesStyle}
        }

        h1 { margin-bottom: 24px; }
        h2 { margin-bottom: 20px; }
        h3 { margin-bottom: 16px; }
        h4 { margin-bottom: 12px; }
        h5 { margin-bottom: 8px; }
        h6 { margin-bottom: 6px; }

        h1, h2, h3, h4, h5, h6 {
          margin-top: 0;
          line-height: 1.3;
        }
      </style>

      <div class="rich-content-body ${internalClassName}">
        ${content || ""}
      </div>
    `;
  }, [content, internalClassName, maxLines]);

  return <div ref={containerRef} className={`w-full ${className}`} style={style} />;
});

export default RichContent;
